// Build url for Api calls to get data for a table
export default function(tableId) {

  // Set element from tableId
  const el = $('#' + tableId);

  // Set params based on filter attributes
  let params = {};
  let data = $('#' + tableId).data();
  $.each(data, function(key, val) {
    if (key.indexOf('filter') !== -1) {
      let k = key.replace("filters", "")
      k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
      k = k.slice(1);
      params[k] = val
    }
  })

  // Add report token if present
  let token = $('#' + tableId).attr('data-token');
  if (typeof token !== 'undefined') {params['token'] = token;}

  // Set url based on chart data attr
  // Include Api prefix
  let url = el.attr('data-api-url');

  // Return url with params
  return url + '?' + $.param(params);

};
